import { render } from "./VennComponent.vue?vue&type=template&id=735b878e"
import script from "./VennComponent.vue?vue&type=script&lang=js"
export * from "./VennComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__